import { createApp } from "vue";
import App from "./App.vue";
// 待精简内容-有很多样式无用的
import "@/assets/css/common.scss";
import "@/assets/css/_flex.scss";
import "@/assets/css/_spacing.scss";
import "@/assets/css/_grid.scss";
import "@/assets/css/element.scss";
import "@/assets/iconfont/iconfont.css";
import "zhihao-ui/dist/index.css";

import "@/assets/css/base.scss";
import "@/assets/css/fonts.scss";

// element icons
import * as Icons from "@element-plus/icons-vue";
// custom directives
import directives from "@/directives/index";
// vue Router
import router from "@/routers";
// pinia store
import pinia from "@/stores";
// 预加载全局组件
import * as preComp from "@/utils/preComp";
import { initSensors } from "@/plugin/sensors.ts";

// 初始化ws
import "@/api/socketIOManager";

const clearCaches = async () => {
    if ("caches" in window) {
        const cacheNames = await caches.keys();
        await Promise.all(cacheNames.map(cacheName => caches.delete(cacheName)));
    }
};

initSensors();

clearCaches();

const app = createApp(App);

Object.keys(preComp).forEach(key => {
    app.component(key, preComp[key as keyof typeof preComp]);
});

// register the element Icons component
Object.keys(Icons).forEach(key => {
    app.component(key, Icons[key as keyof typeof Icons]);
});

app.use(directives).use(router).use(pinia).mount("#app");

// const clearCaches = async () => {
//     if ('caches' in window) {
//         const cacheNames = await caches.keys();
//         await Promise.all(cacheNames.map((cacheName) => caches.delete(cacheName)));
//     }
// };
//
// clearCaches();
